<template>
  <div style="pointer-events:none;">
  <v-layout style="position:fixed;width:100vw;" class="pl-8 pr-8" fill-height v-if="activeTour != null">
    <v-row justify="center" :align="($vuetify.breakpoint.smAndDown) ? 'end' : 'center'" :class="($vuetify.breakpoint.smAndDown) ? 'pb-8' : ''">
       <v-col cols="auto" class="pa-0 ma-0">
        <v-btn class="ma-0" style="pointer-events:auto;" :small="$vuetify.breakpoint.smAndDown" :x-large="!$vuetify.breakpoint.smAndDown"  dark color="rgba(0,0,0,0.6)" :disabled="activeTourIndex == 0" @click="OnTapPrevTourPoint()">
          <v-icon left x-large color="#ff00ff">
            mdi-chevron-left
          </v-icon>
          PREVIOUS STOP
        </v-btn>
      </v-col>
      <v-spacer/>
      <v-col cols="auto" class="pa-0 ma-0">
        <v-btn class="ma-0" style="pointer-events:auto;" :small="$vuetify.breakpoint.smAndDown" :x-large="!$vuetify.breakpoint.smAndDown"  dark color="rgba(0,0,0,0.6)" @click="(activeTourIndex == activeTour.tourPoints.length - 1) ?  CloseTour() : OnTapNextTourPoint()">
          {{(activeTourIndex == activeTour.tourPoints.length - 1) ? 'END TOUR' : 'NEXT STOP'}}
           <v-icon right x-large color="#ff00ff">
            mdi-chevron-right
          </v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </v-layout>
  <v-layout style="position:fixed;top:0px;bottom:10px;left:0px;right:0px;" v-if="waypoint != null && waypoint.otherSideWaypoint != null && waypoint.otherSideWaypoint != ''">
    <v-row align="end" justify="center" v-if="showOtherSideOption">
      <v-col cols="auto">
        <v-btn color="pink" @click="GoTOOtherSide" style="pointer-events:auto;" dark>
        Other Side
        </v-btn>
      </v-col>
    </v-row>
  </v-layout>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import { mapMutations } from 'vuex'
import { off } from 'process';
export default {
  name: 'CubeNavigator',
  components: {
  },
  props: {
    isActive : false,
    babylonPanelIdentifier : "",
    navigationMethod : "",
    waypoints : Array,
    waypoint : null,
    allowFloorMovement : false,
    resetRotationOnMove : false,
    fixtureNavActive : false,
    activeFixture : null,
    cursorOverProduct : false,
    targetTouchpoint : null
  },
  computed: {
    ...mapState("sessionState", [
        "forceLandRotation",
        "activeTour",
        "activeTourIndex",
        "package",
        "videoGroups",
        "isProductFocused"
    ]),
    ...mapState("commercialState", [
        "activeCart"
    ]),
    ...mapGetters("sessionState", [
        "GetBabPnl",
        "CurrentStageData"
    ]),

  },

  mounted ()  {

    this.$options.imageCache = [];
    this.$options.loadingTextures = [];
    this.$options.loadingWaypoints = [];
    this.$options.loadedWaypoints = [];
    this.$options.loadingTextureObjects = [];
    
  },
  data: () => ({

    animationSpeed : 7,
    fadeModel : null,
    useCubicEasing : true,
    currentWaypoint : null,
    processedWaypoints : null,
    loadingMeshes : [],
    firstWaypoint : true,
    focusedProduct : null,
    isRotating : false,
    isMoving : false,
    snackbar : false,
    timeout : 2000,
    snackbarText : "",
    transitionMethod : "FADE1",
    shiftHeldDown : false,
    allowWaypointChange : true,
    focusedPlanogramid : null,
    checkedKeyOnce : false,
    canNavigate : false,
    showOtherSideOption : false,
    forceLookDir : false,

  }),
  methods: {

     ...mapMutations("sessionState", [
      "SetForceLandRotation",
      "GoNextTourPoint",
      "GoPrevTourPoint",
      "CloseTour",
      "SetVideoGroupsToPlay"
    ]),

    GoTOOtherSide()
    {
      this.forceLookDir = true;
      this.currentWaypoint = this.waypoints.find(waypoint => waypoint.id == this.waypoint.otherSideWaypoint);
    },

    OnTapNextTourPoint()
    {
      this.SetForceLandRotation(true);
      this.GoNextTourPoint();
    },
    OnTapPrevTourPoint()
    {
      this.SetForceLandRotation(true);
      this.GoPrevTourPoint();
    },
    
    ShowSnackbar(text)
    {
      this.snackbar = true;
      this.snackbarText = text;
    },
    Init()
    {
      this.CreateCamera();
      this.LoadCubeAndInitialSpheres();
    },
    CreateCamera()
    {
      var inst = this.GetBabPnl(this.babylonPanelIdentifier);
      var camera = new BABYLON.FreeCamera("UniversalCamera", new BABYLON.Vector3(0, 0, 0), inst.scene);
      camera.fov = 1;

      if(this.package.settings.uniqueProjectid == "nestle")
      {
        camera.fov = 1.3;
      }
      else
      {
        camera.fov = 1;
      }

      camera.lowerRadiusLimit = 0.001;
      camera.upperRadiusLimit = 0.001;
      camera.allowUpsideDown = false;
      camera.minZ = 0.01;
      camera.inputs.attached.mouse.angularSensibility = camera.inputs.attached.mouse.angularSensibility * -4
      camera.interia = 0.2;
      var inputManager = camera.inputs;
      camera.attachControl(inst.canvas, true);
      this.$options.camera = camera;

      camera.inputs.attached.keyboard.detachControl();

      if(this.navigationMethod == "CUBE_FREEROAM")
      {
        camera.inputs.attached.mouse.detachControl();
      }
      
      this.$options.mainUi = BABYLON.GUI.AdvancedDynamicTexture.CreateFullscreenUI("UI",true);

      inst.scene.registerBeforeRender(() => {

      })


      if(this.waypoints.length > 0)
      {
        let startingWaypoint = this.waypoints[0];
        camera.position = new BABYLON.Vector3(startingWaypoint.pos.x,startingWaypoint.pos.y,startingWaypoint.pos.z);
        camera.rotation = new BABYLON.Vector3(BABYLON.Tools.ToRadians(startingWaypoint.euler.x),BABYLON.Tools.ToRadians(startingWaypoint.euler.y),0);
        this.currentWaypoint = startingWaypoint;
      }

      if(this.navigationMethod == "CUBE_FREEROAM")
      {
        document.addEventListener('keydown', (evt) => {

          if(evt.key == "Control")
          {
            this.shiftHeldDown = true;
          }

          if(this.isProductFocused)
          {
             return;
          }

          if(this.focusedProduct != null)
          {
            if(evt.key == " " && !evt.repeat)
            {
              
              this.$emit("ClickFocusedItem",this.focusedProduct);
            }
          }
          
          //Rotation
          if (evt.key == "ArrowLeft" ||  evt.key.toLowerCase() == "a")
          {
            if(this.shiftHeldDown)
            {
              this.Move("Left");
            }
            else
            {
              this.Rotate(true);
            }
          }

          if ( evt.key  == "ArrowRight" || evt.key.toLowerCase() == "d")
          { 
            if(this.shiftHeldDown)
            {
              this.Move("Right");
            }
            else
            {
              this.Rotate(false);
            }
          }
          

          //Movement
          if(evt.key == "ArrowUp" || evt.key.toLowerCase() == "w")
          {
            this.Move("Forward");
          }

          if(evt.key == "ArrowDown" || evt.key.toLowerCase() == "s")
          {
            this.Move("Back");
          }
        });

        document.addEventListener('keyup', (evt) => {

          if(evt.key == "Control")
          {
            this.shiftHeldDown = false;
          }

          if(evt.key == " ")
          {
            this.checkedKeyOnce = false;
          }
          

        });

      }

      inst.scene.registerBeforeRender(() => {

        if(this.currentWaypoint != null)
        {
          if(this.currentWaypoint.otherSideWaypoint != null && this.currentWaypoint.otherSideWaypoint != '')
          {
            var camDir = inst.scene.activeCamera.getForwardRay().direction;
            let forwardDir = new BABYLON.Vector3(this.currentWaypoint.forwardX, this.currentWaypoint.forwardY,this.currentWaypoint.forwardZ);
            let dot = BABYLON.Vector3.Dot(forwardDir,camDir);

            if(dot > 0.7)
            {
              this.showOtherSideOption = true;
            }
            else
            {
              this.showOtherSideOption = false;
            }
          }
        }
          
        if(this.$options.floor != null && this.activeTour == null)
        {

          let camPos = inst.scene.activeCamera.position.clone();
          camPos.y = camPos.y - 1.7;
          this.$options.floor.position = camPos;

          var ray = inst.scene.createPickingRay(inst.scene.pointerX, inst.scene.pointerY, BABYLON.Matrix.Identity(), camera);	
          //var hit = inst.scene.pickWithRay(ray, (mesh) => mesh == this.$options.floor);
          var hit = inst.scene.pickWithRay(ray, null);
    
          if(hit.hit && hit.pickedMesh.name == this.$options.floor.name && !this.isProductFocused && !this.cursorOverProduct)
          {
            var hitPos = hit.pickedPoint.clone();
            let distance = BABYLON.Vector3.Distance(hitPos,camPos);


            if(distance < 24)
            {
              this.canNavigate = true;
              let lookPosition = hit.pickedPoint.clone().subtract(hit.getNormal(false));
              this.$options.floorMarker.position = hitPos;
              this.$options.floorMarker.lookAt(lookPosition);
              this.$options.floorMarker.visibility = 1;

              if(this.currentWaypoint != null)
              {
                let closestWaypoint = this.ClosestWaypointToPoint(hitPos);

                if(this.currentWaypoint.id == closestWaypoint.id)
                {
                  this.$options.floorMarker.visibility = 0.3;
                  this.$options.floorMarker.material.emissiveColor = new BABYLON.Color3(1, 0, 0);
                  this.$options.floorMarker.material.diffuseColor  = new BABYLON.Color3(1, 0, 0);
                }
                else
                {
                  this.$options.floorMarker.visibility = 1;
                  this.$options.floorMarker.material.emissiveColor = new BABYLON.Color3(0, 1, 0);
                  this.$options.floorMarker.material.diffuseColor  = new BABYLON.Color3(0, 1, 0);
                }
              }

              

            }
            else
            {
              this.canNavigate = false;
              this.$options.floorMarker.visibility = 0;
            }
          }
          else
          {
            this.canNavigate = false;
            this.$options.floorMarker.visibility = 0;
          }
        }

      });

      inst.scene.onPointerObservable.add((pointerInfo) => {

        if(pointerInfo.type == BABYLON.PointerEventTypes.POINTERDOWN)
        {
          this.$options.pointerX = inst.scene.pointerX;
          this.$options.pointerY = inst.scene.pointerY;
        }
        else if(pointerInfo.type == BABYLON.PointerEventTypes.POINTERUP)
        {
          if(this.$options.floor != null && this.canNavigate && this.activeTour == null)
          {
            if(Math.abs(inst.scene.pointerX - this.$options.pointerX) < 20 && Math.abs(inst.scene.pointerY - this.$options.pointerY) < 20)
            {
              var ray = inst.scene.createPickingRay(inst.scene.pointerX, inst.scene.pointerY, BABYLON.Matrix.Identity(), camera);	
              var hit = inst.scene.pickWithRay(ray, (mesh) => mesh == this.$options.floor);

              if(hit.hit && !this.isProductFocused)
              {
                let closestWaypoint = this.ClosestWaypointToPoint(hit.pickedPoint);

                if(closestWaypoint.id != this.currentWaypoint.id)
                {
                  this.NavigateToWaypoint(closestWaypoint);
                }
              }
            }
          }
        }

      })

      this.$emit("initalized");
      
    },
    ClosestWaypointToPoint(pointer)
    {
      let closestWaypoint = null;
      let closestDistance = 99999;
      for(let w = 0; w < this.waypoints.length;w++)
      {
        const compareWypn = this.waypoints[w];

        let compareWypnPOS = new BABYLON.Vector3(
        compareWypn.pos.x, 
        compareWypn.pos.y, 
        compareWypn.pos.z);

        let distance = BABYLON.Vector3.Distance(pointer,compareWypnPOS);

        if(distance < closestDistance)
        {
          closestWaypoint = compareWypn;
          closestDistance = distance;
        }
      }

      return closestWaypoint;
    },
    CastRayFromCamera(origin, direction)
    {
      var inst = this.GetBabPnl(this.babylonPanelIdentifier);
      var ray = new BABYLON.Ray(origin,direction,4)
      var hit = inst.scene.pickWithRay(ray);

      //Did we hit a wallpaper?
      if(hit.pickedMesh != null)
      {
        let splitString = hit.pickedMesh.name.split("-");
        let productKey = splitString[0];

        this.focusedProduct = this.CurrentStageData.products.find(product => product.id == productKey);
        this.focusedPlanogramid = splitString[1];
        this.focusedProduct.planogram = this.focusedPlanogramid;
        this.$emit("LookAtPlanogram", this.focusedPlanogramid);
      }
      else
      {
        this.focusedProduct = null;
        this.focusedPlanogramid = null;
      }
    },
    OnClickFocusedItem()
    {

      this.$emit("ClickFocusedItem",this.focusedProduct);
    },
    Move(direction)
    {
      if(this.isMoving || this.isRotating || !this.allowWaypointChange) 
        return;

      var inst = this.GetBabPnl(this.babylonPanelIdentifier);
      var camDir = inst.scene.activeCamera.getForwardRay().direction;
      var curPos = new BABYLON.Vector3(this.currentWaypoint.pos.x,this.currentWaypoint.pos.y,this.currentWaypoint.pos.z);

      if(direction == "Forward")
      {
        
      }
      else if (direction == "Back")
      {
        camDir.x = -camDir.x;
        camDir.z = -camDir.z;
      }
      else if (direction == "Left")
      {
        camDir = inst.scene.activeCamera.getDirection(new BABYLON.Vector3(-1,0,0));
      }
      else if (direction == "Right")
      {
        camDir = inst.scene.activeCamera.getDirection(new BABYLON.Vector3(1,0,0));
      }

      var targetWaypoint = null;

      for (let i = 0; i < this.currentWaypoint.connectedWaypoints.length; i++) {

        const element = this.currentWaypoint.connectedWaypoints[i];

        let wypn = this.CurrentStageData.waypoints.find(waypoint => waypoint.id == element.id);

        let compareWypnPOS = new BABYLON.Vector3(
          wypn.pos.x, 
          wypn.pos.y, 
          wypn.pos.z
        );

        let dirVec = compareWypnPOS.subtract(curPos).normalize();
        let dot = BABYLON.Vector3.Dot(dirVec,camDir);

        if(dot > 0.5)
        {
          targetWaypoint = wypn;
        }
      }

      if(targetWaypoint != null)
      {
        const vec = inst.scene.activeCamera.getDirection( new BABYLON.Vector3(0,0,1));
        let rayPosition = new BABYLON.Vector3(targetWaypoint.pos.x,targetWaypoint.pos.y,targetWaypoint.pos.z);
        rayPosition.y -= 0.7;
        this.CastRayFromCamera(rayPosition,vec);

        this.NavigateToWaypoint(targetWaypoint);
      }
      else
      {
        this.ShowSnackbar("Cannot move forward, please try moving along first.")
      }
        
    },
    Rotate(isLeft)
    {
      if(this.isRotating || this.isMoving)
        return;

      var inst = this.GetBabPnl(this.babylonPanelIdentifier);
      var animationcamera = new BABYLON.Animation(
          "myAnimationcamera", 
          "rotation", 
          30, 
          BABYLON.Animation.ANIMATIONTYPE_VECTOR3, 
          BABYLON.Animation.ANIMATIONLOOPMODE_CONSTANT
      );

      var keys = [];
      keys.push({
        frame: 0,
        value: inst.scene.activeCamera.rotation.clone(),
      });

      const vec = inst.scene.activeCamera.getDirection(new BABYLON.Vector3((isLeft) ? -1 : 1,0,0));

      let rayPosition = inst.scene.activeCamera.position.clone();
      rayPosition.y -= 0.7;
      this.CastRayFromCamera(rayPosition,vec);

      let dstRotation = inst.scene.activeCamera.rotation.clone();
      dstRotation.y +=  (isLeft) ? -1.57 : 1.57;

      if(this.focusedProduct != null)
      {
        dstRotation.x = 0.28;
        //inst.scene.activeCamera.fov = 1.2;
      }
      else
      {
        dstRotation.x = 0;
        //inst.scene.activeCamera.fov = 1.0;
      }

     

      keys.push({
        frame: 15,
        value: dstRotation,
      });
      
      animationcamera.setKeys(keys);

      inst.scene.activeCamera.animations = [];
      inst.scene.activeCamera.animations.push(animationcamera);

      this.isRotating = true;
      inst.scene.beginAnimation(inst.scene.activeCamera, 0, 15, false, 1, () => {
        
        this.isRotating = false;
        
      });
    },
    StartLODLoop()
    {
      var inst = this.GetBabPnl(this.babylonPanelIdentifier);

      inst.scene.registerAfterRender(() => {

        if(this.currentWaypoint == null || this.$options.currentCube == null)
          return;

        let lodLevel = "m";
        let cameraForward = this.$options.camera.getDirection(new BABYLON.Vector3(0,0,1));

        if(this.$options.camera.fov < 0.8)
        {
          if(this.$options.camera.fov < 0.5 && this.package.settings.qualtiyMode == 2)
          {
            lodLevel = "uh";
          }
          else
          {
            lodLevel = "h";
          }
        }

        if(this.focusedProduct != null)
        {
          lodLevel = "h";
        }

        if(lodLevel == "m")
        {
          this.$options.currentCube.getChildren(child => child.name == "LOD M Cube",true)[0].getChildren().forEach(face => {
             //Foreach invisible face, let's see if it is in frustrum, if so lets begin the load and set its visibility when done
             if(face.visibility == 0)
             {
               let targetVec = face.position.clone().normalize();
               targetVec = targetVec.multiply(new BABYLON.Vector3(-1,1,1));
               let dot = BABYLON.Vector3.Dot(targetVec,cameraForward);

               if(dot > 0.5)
               {
                 
                  if(!this.loadingMeshes.includes("m_" + face.name))
                  {
                    let targetUrl = this.currentWaypoint.cubeUrl + "/m/" + this.currentWaypoint.cubeid + "_m_" + face.name + ".jpg";

                    this.$options.loadingTextures.push({url : targetUrl, cube : this.$options.currentCube.name});
                    this.BeginLoadTextureForMeshFromUrl(this.currentWaypoint.id,face,targetUrl,inst.scene,(newTex) => {

                      let foundLoadingValIndex = this.$options.loadingTextures.findIndex(loadingTex => loadingTex.url == targetUrl);

                      if(foundLoadingValIndex > -1)
                      {
                        let foundLoadingVal = this.$options.loadingTextures[foundLoadingValIndex];

                        if(foundLoadingVal.cube == this.$options.currentCube.name)
                        {
                          face.visibility = 1;
                          this.loadingMeshes.splice(this.loadingMeshes.indexOf("m_" + face.name),1);
                        }
                        else
                        {
                          //This we loaded for a prior cube and so should be disposed
                          newTex.dispose();
                        }

                        this.$options.loadingTextures.splice(foundLoadingValIndex,1);
                      }
                    })
                    this.loadingMeshes.push("m_" + face.name);
                  }
               }
             }
           });
        
          this.$options.currentCube.getChildren(child => child.name == "LOD H Cube",true)[0].getChildren().forEach(face => {
            if(face.visibility != 0)
            {
              face.visibility = 0;
            }
          });

          this.$options.currentCube.getChildren(child => child.name == "LOD UH Cube",true)[0].getChildren().forEach(face => {
            if(face.visibility != 0)
            {
              face.visibility = 0;
            }
          });
        }
        else if (lodLevel == "h")
        {
          this.$options.currentCube.getChildren(child => child.name == "LOD H Cube",true)[0].getChildren().forEach(face => {
             //Foreach invisible face, let's see if it is in frustrum, if so lets begin the load and set its visibility when done
             if(face.visibility == 0)
             {
               let targetVec = face.position.clone().normalize();
               targetVec = targetVec.multiply(new BABYLON.Vector3(-1,1,1));
               let dot = BABYLON.Vector3.Dot(targetVec,cameraForward);

               if(dot > 0.6)
               {
                  if(!this.loadingMeshes.includes("h_" + face.name))
                  {
                   
                    let targetUrl = this.currentWaypoint.cubeUrl + "/h/" +  this.currentWaypoint.cubeid + "_h_" + face.name + ".jpg";
                    this.$options.loadingTextures.push({url : targetUrl, cube : this.$options.currentCube.name});
                    this.BeginLoadTextureForMeshFromUrl(this.currentWaypoint.id,face,targetUrl,inst.scene,(newTex) => {

                      let foundLoadingValIndex = this.$options.loadingTextures.findIndex(loadingTex => loadingTex.url == targetUrl);

                      if(foundLoadingValIndex > -1)
                      {
                        let foundLoadingVal = this.$options.loadingTextures[foundLoadingValIndex];

                        if(foundLoadingVal.cube == this.$options.currentCube.name)
                        {
                          face.visibility = 1;
                          this.loadingMeshes.splice(this.loadingMeshes.indexOf("h_" + face.name),1);
                        }
                        else
                        {
                          //This we loaded for a prior cube and so should be disposed
                          newTex.dispose();
                        }

                        this.$options.loadingTextures.splice(foundLoadingValIndex,1);
                      }
                    })
                    this.loadingMeshes.push("h_" + face.name);
                  }
                  else if (face.material.emissiveTexture != null)
                  {
                    face.visibility = 1;
                  }
               }
             }
           });
        
          this.$options.currentCube.getChildren(child => child.name == "LOD UH Cube",true)[0].getChildren().forEach(face => {
            if(face.visibility != 0)
            {
              face.visibility = 0;
            }
          });
        }
        else if (lodLevel == "uh")
        {
           this.$options.currentCube.getChildren(child => child.name == "LOD UH Cube",true)[0].getChildren().forEach(face => {
             //Foreach invisible face, let's see if it is in frustrum, if so lets begin the load and set its visibility when done
             if(face.visibility == 0)
             {
               let targetVec = face.position.clone().normalize();
               targetVec = targetVec.multiply(new BABYLON.Vector3(-1,1,1));
               let dot = BABYLON.Vector3.Dot(targetVec,cameraForward);

               if(dot > 0.7)
               {
                  if(!this.loadingMeshes.includes("uh_" + face.name))
                  {
                   
                    let targetUrl = this.currentWaypoint.cubeUrl + "/uh/" +  this.currentWaypoint.cubeid + "_uh_" + face.name + ".jpg";
                    this.$options.loadingTextures.push({url : targetUrl, cube : this.$options.currentCube.name});
                    this.BeginLoadTextureForMeshFromUrl(this.currentWaypoint.id, face,targetUrl,inst.scene,(newTex) => {

                      let foundLoadingValIndex = this.$options.loadingTextures.findIndex(loadingTex => loadingTex.url == targetUrl);

                      if(foundLoadingValIndex > -1)
                      {
                        let foundLoadingVal = this.$options.loadingTextures[foundLoadingValIndex];

                        if(foundLoadingVal.cube == this.$options.currentCube.name)
                        {
                          face.visibility = 1;
                          this.loadingMeshes.splice(this.loadingMeshes.indexOf("uh_" + face.name),1);
                        }
                        else
                        {
                          //This we loaded for a prior cube and so should be disposed
                          newTex.dispose();
                        }

                        this.$options.loadingTextures.splice(foundLoadingValIndex,1);
                      }
                    })
                    this.loadingMeshes.push("uh_" + face.name);
                  }
                  
               }
             }
             else if (face.material.emissiveTexture != null)
            {
              face.visibility = 1;
            }
           });
        }
      });
     
    },
    PopulateCubeForwaypoint(cube,waypoint,scene)
    {
      cube.scaling = new BABYLON.Vector3(4,4,4);
      cube.position = new BABYLON.Vector3(waypoint.pos.x,waypoint.pos.y,waypoint.pos.z);

      cube.getChildren(child => child.name == "LOD L Cube",true)[0].getChildren().forEach(face => {
        
        let targetTexture = waypoint.cubeUrl + "/l/" + waypoint.cubeid + "_l_" + face.name + "_0.jpg";

        let foundBuffer = this.$options.imageCache.find(obj => obj.image.src == targetTexture);

        if(foundBuffer == null)
        {
          var newTex = new BABYLON.Texture(targetTexture, scene,{noMipmap : true},undefined,undefined,undefined,undefined);
          face.material.emissiveTexture = newTex;
          face.visibility = 1;
          face.alphaIndex  = 11;
        }
        else
        {
          var newTex = new BABYLON.Texture(targetTexture, scene,{noMipmap : true},undefined,undefined,undefined,undefined,foundBuffer.image);
          face.material.emissiveTexture = newTex;
          face.visibility = 1;
          face.alphaIndex  = 11;
        }
        
     
      });

      cube.getChildren(child => child.name == "LOD M Cube",true)[0].getChildren().forEach(face => {
        face.visibility = 0;
        face.alphaIndex  = 12;
      });

        cube.getChildren(child => child.name == "LOD H Cube",true)[0].getChildren().forEach(face => {
        face.visibility = 0;
        face.alphaIndex  = 13;
      });

        cube.getChildren(child => child.name == "LOD UH Cube",true)[0].getChildren().forEach(face => {
        face.visibility = 0;
        face.alphaIndex  = 14;
      });


    },
    NavigateToWaypoint(waypoint)
    {
      if(this.isMoving || !this.allowWaypointChange)
        return;

      if(!this.$options.loadedWaypoints.some(loadedWaypoint => loadedWaypoint.id == waypoint.id))
      {
        //return;
      }
      var inst = this.GetBabPnl(this.babylonPanelIdentifier);

      if(this.firstWaypoint)
      {
        if(this.firstWaypoint)
          this.$options.camera.position = new BABYLON.Vector3(waypoint.pos.x,waypoint.pos.y,waypoint.pos.z);

        if(this.activeFixture != null)
        {
          let targetLookat = new BABYLON.Vector3(this.activeFixture.colInfo.pos.x,this.activeFixture.colInfo.pos.y,this.activeFixture.colInfo.pos.z);
          this.$options.camera.setTarget(targetLookat);
        }
        else
        {
          this.$options.camera.rotation = new BABYLON.Vector3(BABYLON.Tools.ToRadians(waypoint.euler.x),BABYLON.Tools.ToRadians(waypoint.euler.y),0);
        }
        
        this.firstWaypoint = false;
      }
      else
      {
        this.CachePreviewsForNearbyWaypoints(10);
      }

      this.allowWaypointChange = false;
      this.$options.targetCube = (this.$options.currentCube != this.$options.lodCubeAlpha) ? this.$options.lodCubeAlpha : this.$options.lodCubeBeta;
      let currentCube = this.$options.currentCube;
      let targetCube = this.$options.targetCube;
      
      if(currentCube != null)
      {
        //Stop loading any textures for former cube
        //Fadeout old cube
        currentCube.scaling = new BABYLON.Vector3(0.8,0.8,0.8);
        this.isMoving = true;

        if(this.transitionMethod == "FADE")
        {
          this.$options.camera.position = new BABYLON.Vector3(waypoint.pos.x,waypoint.pos.y,waypoint.pos.z);
          currentCube.position = new BABYLON.Vector3(waypoint.pos.x,waypoint.pos.y,waypoint.pos.z);
        }
        else
        {
          
          this.AnimateCamera(this.forceLandRotation,new BABYLON.Vector3(waypoint.euler.x,waypoint.euler.y,waypoint.euler.z),new BABYLON.Vector3(waypoint.pos.x,waypoint.pos.y,waypoint.pos.z),() =>
          {
            if(this.forceLandRotation && this.targetTouchpoint != null)
            {
              let facePosition = new BABYLON.Vector3(this.targetTouchpoint.pos.x,this.targetTouchpoint.pos.y,this.targetTouchpoint.pos.z);
              let targety = (this.targetTouchpoint.pos.y < this.$options.camera.position.y) ? this.$options.camera.position.y : this.targetTouchpoint.pos.y + 0.05;

              facePosition.y = targety;
              //Rotate to face touchpoint
              //let dstY = (this.$options.camera.position.y > this.targetTouchpoint.position.y) ? this.$options.camera.position.y : this.targetTouchpoint.y;
              // dstY += 0.1;
              this.$options.camera.setTarget(facePosition);
            }

            if(this.forceLookDir)
            {
              this.$options.camera.rotation = new BABYLON.Vector3(BABYLON.Tools.ToRadians(waypoint.euler.x),BABYLON.Tools.ToRadians(waypoint.euler.y),0);
              this.forceLookDir = false;
            }

            if(this.forceLandRotation)
            {
              this.SetForceLandRotation(false);
            }

            this.isMoving=false;
            this.CleanupCube(currentCube);
            this.UpdateFloorMarkers();

          });
          
        }
        
        currentCube.getChildMeshes().forEach(mesh => {
          if(mesh.visibility != 0 && mesh.material != null)
          {
            mesh.alphaIndex = mesh.alphaIndex - 10;
            this.FadeMesh(mesh,0);
          }
        });
        
      }
      else
      {
         this.$options.camera.position = new BABYLON.Vector3(waypoint.pos.x,waypoint.pos.y,waypoint.pos.z);
      }


      setTimeout(() => {


        this.allowWaypointChange = true;
        this.$emit("WaypointLoaded",waypoint);
        
        if(currentCube == null)
        {
          this.UpdateFloorMarkers();
        }
        
      }, 500);
      
      this.$options.currentCube = targetCube;
      this.loadingMeshes = [];
      this.$options.loadingTextures = [];

      this.PopulateCubeForwaypoint(targetCube,waypoint,inst.scene);

      this.currentWaypoint = waypoint;
    },
    CleanupCube(cube)
    {
      cube.getChildMeshes().forEach(mesh => {
        if(mesh.material != null && mesh.material.emissiveTexture != null)
        {
          mesh.material.emissiveTexture.dispose();
          mesh.material.emissiveTexture = null;
        }
      });
    },
    FadeMesh(mesh,toFade)
    {
      var inst = this.GetBabPnl(this.babylonPanelIdentifier);
      var fadeAnimation = new BABYLON.Animation(
          "FadeAnimation", 
          "visibility", 
          30, 
          BABYLON.Animation.ANIMATIONTYPE_FLOAT, 
          BABYLON.Animation.ANIMATIONLOOPMODE_CONSTANT
      );

      var keys = []; 

      keys.push({
        frame: 0,
        value: mesh.visibility,
      });

      keys.push({
        frame: 50,
        value: 0,
      });

      fadeAnimation.setKeys(keys);

      if(this.useCubicEasing)
      {
        var ease = new BABYLON.CubicEase();
        ease.setEasingMode(BABYLON.EasingFunction.EASINGMODE_EASEINOUT);
        fadeAnimation.setEasingFunction(ease);
      }
      

      mesh.animations = [];
      mesh.animations.push(fadeAnimation);

      let animSpeed = 2;

      if(this.transitionMethod == "FADE")
      {
        animSpeed = 3;
      }

      inst.scene.beginAnimation(mesh, 0, 50, false, this.animationSpeed);
      
    },
    AnimateCamera(forceRotation, waypointEuler, toPosition, callBack)
    {
      var inst = this.GetBabPnl(this.babylonPanelIdentifier);
      var animationcamera = new BABYLON.Animation(
          "CameraTransition", 
          "position", 
          30, 
          BABYLON.Animation.ANIMATIONTYPE_VECTOR3, 
          BABYLON.Animation.ANIMATIONLOOPMODE_CONSTANT
      );

      var keys = []; 

      keys.push({
      frame: 0,
      value: inst.scene.activeCamera.position.clone(),
      // outTangent: new BABYLON.Vector3(1, 0, 0)
      });

      keys.push({
      frame: 50,
      value: toPosition,
      });

      animationcamera.setKeys(keys);

      if(this.useCubicEasing)
      {
        var ease = new BABYLON.CubicEase();
        ease.setEasingMode(BABYLON.EasingFunction.EASINGMODE_EASEINOUT);
        animationcamera.setEasingFunction(ease);
      }

      inst.scene.activeCamera.animations = [];
      inst.scene.activeCamera.animations.push(animationcamera);

      if(this.resetRotationOnMove || forceRotation)
      {
        var cameraRotation = new BABYLON.Animation(
            "myAnimationcamera", 
            "rotation", 
            30, 
            BABYLON.Animation.ANIMATIONTYPE_VECTOR3, 
            BABYLON.Animation.ANIMATIONLOOPMODE_CONSTANT
        );

        //Rotate animation
        var rotationKeys = [];
        rotationKeys.push({
          frame: 0,
          value: inst.scene.activeCamera.rotation.clone(),
        });

        let dstRotation = inst.scene.activeCamera.rotation.clone();

        dstRotation.x = BABYLON.Tools.ToRadians(waypointEuler.x);
        dstRotation.y = BABYLON.Tools.ToRadians(waypointEuler.y);
      
     
        //-----------------

        rotationKeys.push({
          frame: 15,
          value: dstRotation,
        });
        
        cameraRotation.setKeys(rotationKeys);

        inst.scene.activeCamera.animations.push(cameraRotation);
      }

      inst.scene.beginAnimation(inst.scene.activeCamera, 0, 50, false, this.animationSpeed, callBack);
    },
    RotateCameraToFaceProducts(callback)
    {
      var inst = this.GetBabPnl(this.babylonPanelIdentifier);
      var cameraRotation = new BABYLON.Animation(
          "myAnimationcamera", 
          "rotation", 
          30, 
          BABYLON.Animation.ANIMATIONTYPE_VECTOR3, 
          BABYLON.Animation.ANIMATIONLOOPMODE_CONSTANT
      );

      //Rotate animation
      var rotationKeys = [];
      rotationKeys.push({
        frame: 0,
        value: inst.scene.activeCamera.rotation.clone(),
      });

      let dstRotation = inst.scene.activeCamera.rotation.clone();

      if(this.focusedProduct != null)
      {
        dstRotation.x =  0.28;
      }
      else
      {
        dstRotation.x = 0;
      }
      //-----------------

      rotationKeys.push({
        frame: 15,
        value: dstRotation,
      });
      
      cameraRotation.setKeys(rotationKeys);

      inst.scene.activeCamera.animations = [];
      inst.scene.activeCamera.animations.push(cameraRotation);

      inst.scene.beginAnimation(inst.scene.activeCamera, 0, 15, false, this.animationSpeed, callback);
    },
    ProcessWaypoints()
    {
      this.processedWaypoints = [];
      
      for (let i = 0; i < this.waypoints.length; i++) {

        const wypn = this.waypoints[i];

        if(wypn.connectedWaypoints != null && wypn.connectedWaypoints.length != 0)
        {

          let waypointArray = [];

          for (let i = 0; i < wypn.connectedWaypoints.length; i++) {
            
            let element = wypn.connectedWaypoints[i];
            let filteredWaypoint = this.waypoints.filter(w => w.id == element);
            waypointArray.push(filteredWaypoint[0]);
          }

          wypn.connectedWaypoints = waypointArray;
          this.processedWaypoints.push(wypn);
          continue;
        }
          
        wypn.connectedWaypoints = [];
        let wypnPOS = new BABYLON.Vector3(
            wypn.pos.x, 
            wypn.pos.y, 
            wypn.pos.z);


        if(this.navigationMethod == "TIMEDLINEAR")
        { 

          if(i != this.waypoints.length - 1)
          {
            wypn.connectedWaypoints.push(this.waypoints[i + 1])
            this.processedWaypoints.push(wypn);
          }
          else
            this.processedWaypoints.push(wypn);
            
          continue;
        }

        for(let w = 0; w < this.waypoints.length;w++)
        {
          const compareWypn = this.waypoints[w];
          if(compareWypn.id == wypn.id)
            continue;

          if(compareWypn.navigatable != null)
          {
            if(!compareWypn.navigatable)
            {
              continue;
            }
          }

          let compareWypnPOS = new BABYLON.Vector3(
            compareWypn.pos.x, 
            compareWypn.pos.y, 
            compareWypn.pos.z);

          let distance = BABYLON.Vector3.Distance(wypnPOS,compareWypnPOS);

          if(distance < this.waypointVisibilityDistance)
          {
            wypn.connectedWaypoints.push(compareWypn);
          }
        }

        if(wypn.connectedWaypoints.length == 0)
        {

          let wypnPOS = new BABYLON.Vector3(
          wypn.pos.x, 
          wypn.pos.y, 
          wypn.pos.z);

          let closestDistance = 99999;
          let closestWaypoint;

          for(let w = 0; w < this.waypoints.length;w++)
          {
            const compareWypn = this.waypoints[w];

            if(compareWypn.id == wypn.id)
            {
              continue;
            }

            let compareWypnPOS = new BABYLON.Vector3(
            compareWypn.pos.x, 
            compareWypn.pos.y, 
            compareWypn.pos.z);

            let distance = BABYLON.Vector3.Distance(wypnPOS,compareWypnPOS);

            if(distance < 10)
            {
               wypn.connectedWaypoints.push(compareWypn);
            }
          }

         
        }

        

        this.processedWaypoints.push(wypn);
      }
    },
    UpdateFloorMarkers()
    {

      if(this.fixtureNavActive || this.allowFloorMovement)
        return;
      
      if(this.$options.floorMarkers != null)
      {
        for (let i = 0; i < this.$options.floorMarkers.length; i++) {
          this.$options.floorMarkers[i].dispose(true,true);
        }
      }
      this.$options.floorMarkers = [];

      var inst = this.GetBabPnl(this.babylonPanelIdentifier);

      if(this.currentWaypoint.connectedWaypoints == null)
        this.currentWaypoint.connectedWaypoints = [];


      let processedWaypoint = this.processedWaypoints.filter(e => e.id == this.currentWaypoint.id)[0];

      if(processedWaypoint == null)
      return;

      let matchingWaypoints = processedWaypoint.connectedWaypoints;

  

      //let matchingWaypoints = this.processedWaypoints.filter(e => this.currentWaypoint.connectedWaypoints.includes(e.id));

      for (let i = 0; i < matchingWaypoints.length; i++) {

        const waypoint = matchingWaypoints[i];

        if(waypoint == null)
          continue;


        var box = BABYLON.MeshBuilder.CreatePlane("Clickable", {width : 0.037,height: 0.037},inst.scene);
        let dirVec = new BABYLON.Vector3(waypoint.pos.x - this.currentWaypoint.pos.x,0,waypoint.pos.z - this.currentWaypoint.pos.z).normalize();
        let angle = BABYLON.Vector3.GetAngleBetweenVectors(new BABYLON.Vector3(0,0,1), dirVec,  new BABYLON.Vector3(0,1,0));


        box.rotation = new BABYLON.Vector3(1.57079633,angle,0);
        var matBox = new BABYLON.StandardMaterial("matBox", inst.scene);
        matBox.diffuseTexture = new BABYLON.Texture("https://activstoredev.blob.core.windows.net/test/NavArrow.png", inst.scene);
        matBox.diffuseTexture.hasAlpha = true;
        //matBox.emissiveTexture = new BABYLON.Texture("https://activstoredev.blob.core.windows.net/test/WA/WA%20Floor%20Arrow.png", inst.scene);
        matBox.emissiveColor = BABYLON.Color3.White();
        matBox.diffuseColor = new BABYLON.Color3(1.0, 0.1, 0.1);
        box.material = matBox;
        box.isPickable = true;
        box.position = new BABYLON.Vector3(this.currentWaypoint.pos.x,this.currentWaypoint.pos.y - 0.07,this.currentWaypoint.pos.z);


        box.translate(dirVec,0.15,BABYLON.Space.WORLD);
        

       
        this.$options.floorMarkers.push(box);
        box.actionManager = new BABYLON.ActionManager(inst.scene);
        box.actionManager.registerAction(
          new BABYLON.ExecuteCodeAction(
            BABYLON.ActionManager.OnPickTrigger,
            () => {this.OnClickFloorMarker(waypoint)}
          )
        );

        box.actionManager.registerAction(new BABYLON.SetValueAction(BABYLON.ActionManager.OnPointerOutTrigger, box.material, "emissiveColor", BABYLON.Color3.White()));
        box.actionManager.registerAction(new BABYLON.SetValueAction(BABYLON.ActionManager.OnPointerOverTrigger, box.material, "emissiveColor", new BABYLON.Color3(0,1,1)));
        box.actionManager.registerAction(new BABYLON.InterpolateValueAction(BABYLON.ActionManager.OnPointerOutTrigger, box, "scaling", new BABYLON.Vector3(1, 1, 1), 150));
        box.actionManager.registerAction(new BABYLON.InterpolateValueAction(BABYLON.ActionManager.OnPointerOverTrigger, box, "scaling", new BABYLON.Vector3(1.15, 1.15, 1.15), 150));

      }
    },
    OnClickFloorMarker(waypoint)
    {
      this.currentWaypoint = waypoint;
    },
    GetAllWaypointsInRange(srcWaypoint,testDistance)
    {
      let compareSrcWypnPOS = new BABYLON.Vector3(srcWaypoint.pos.x,srcWaypoint.pos.y,srcWaypoint.pos.z);
      var rtnWaypoints = [];
      for (let i = 0; i < this.waypoints.length; i++) {
        let waypoint = this.waypoints[i];

        let compareWypnPOS = new BABYLON.Vector3(
        waypoint.pos.x, 
        waypoint.pos.y, 
        waypoint.pos.z);

        let distance = BABYLON.Vector3.Distance(compareSrcWypnPOS,compareWypnPOS);

        if(distance < testDistance)
        {
          rtnWaypoints.push(waypoint);
        }
      }

      return rtnWaypoints;
    },
    AddWaypointsToLoader(waypoints,assetsManager)
    {
      waypoints.forEach(waypoint => {

        let rootUrl = waypoint.cubeUrl + "/l/" +  waypoint.cubeid + "_l_";

        assetsManager.addImageTask("nx",rootUrl + "nx_0.jpg").onSuccess = (task => {
          this.$options.imageCache.push({url :  waypoint.cubeid + "_l_nx_0", image : task.image});
        })
        assetsManager.addImageTask("px",rootUrl + "px_0.jpg").onSuccess = (task => {
          this.$options.imageCache.push({url : waypoint.cubeid + "_l_px_0", image : task.image});
        })
        assetsManager.addImageTask("ny",rootUrl + "ny_0.jpg").onSuccess = (task => {
          this.$options.imageCache.push({url : waypoint.cubeid + "_l_ny_0", image : task.image});
        })
        assetsManager.addImageTask("py",rootUrl + "py_0.jpg").onSuccess = (task => {
          this.$options.imageCache.push({url : waypoint.cubeid + "_l_py_0", image : task.image});
        })
        assetsManager.addImageTask("nz",rootUrl + "nz_0.jpg").onSuccess = (task => {
          this.$options.imageCache.push({url : waypoint.cubeid + "_l_nz_0", image : task.image});
        })
        assetsManager.addImageTask("pz",rootUrl + "pz_0.jpg").onSuccess = (task => {
          this.$options.imageCache.push({url : waypoint.cubeid + "_l_pz_0", image : task.image});
        })
        
      });
    },
    CachePreviewsForNearbyWaypoints(maxDistance)
    {
      var inst = this.GetBabPnl(this.babylonPanelIdentifier);
      var assetsManager = new BABYLON.AssetsManager(inst.scene);
      assetsManager.useDefaultLoadingScreen = false;

      let validWaypoints = this.waypoints.filter(waypoint => this.$options.loadedWaypoints.every(loadedWaypoint => loadedWaypoint.id != waypoint.id) && this.$options.loadingWaypoints.every(loadingWaypoint => loadingWaypoint.id != waypoint.id));
      let waypointsToSort = [];
      let compareSrcWypnPOS = new BABYLON.Vector3(this.currentWaypoint.pos.x,this.currentWaypoint.pos.y,this.currentWaypoint.pos.z);

      for (let i = 0; i < validWaypoints.length; i++) {
        let waypoint = validWaypoints[i];

        let compareWypnPOS = new BABYLON.Vector3(
        waypoint.pos.x, 
        waypoint.pos.y, 
        waypoint.pos.z);

        let distance = BABYLON.Vector3.Distance(compareSrcWypnPOS,compareWypnPOS);

        waypointsToSort.push({distance : distance, waypoint : waypoint});
        
      }

      waypointsToSort = waypointsToSort.sort((first,second) => { return first.distance > second.distance });

      validWaypoints = [];
      waypointsToSort.forEach(sortedElement => {

        if(sortedElement.distance < maxDistance || validWaypoints.length < 3)
        {
          validWaypoints.push(sortedElement.waypoint);
          this.$options.loadingWaypoints.push(sortedElement.waypoint);
        }
      });

      this.AddWaypointsToLoader(validWaypoints,assetsManager);

      assetsManager.onFinish = (tasks) => {

        validWaypoints.forEach(waypoint => {
          this.$options.loadedWaypoints.push(waypoint);
        });

        this.$options.loadingWaypoints = this.$options.loadingWaypoints.filter(waypoint => validWaypoints.every(loadedWaypoint => loadedWaypoint.id != waypoint.id));

      }

      assetsManager.load();
    },
    AllTasksCompleted(tasks)
    {
      let allFinished = tasks.every(task => task.isCompleted);
      return allFinished;
    },
    LoadCubeAndInitialSpheres()
    {
      this.$options.lodMeshes = [];

      var inst = this.GetBabPnl(this.babylonPanelIdentifier);
      var assetsManager = new BABYLON.AssetsManager(inst.scene);

      this.$options.lodCubeAlpha = new BABYLON.TransformNode("LOD Cube Alpha", inst.scene,true);

      if(this.navigationMethod == "CUBE" && this.allowFloorMovement)
      {
        this.$options.floor = BABYLON.Mesh.CreateBox("box", 1, inst.scene);
        this.$options.floor.scaling = new BABYLON.Vector3(50,0.1,50);
        this.$options.floor.visibility = 0;

        this.$options.floorMarker = BABYLON.MeshBuilder.CreatePlane("FloorMarker", {width : 0.75,height: 0.75},inst.scene);
        var matBox = new BABYLON.StandardMaterial("FloorMarker", inst.scene);
        matBox.diffuseTexture = new BABYLON.Texture("https://activstoredev.blob.core.windows.net/test/FloorMarkerWhite.png", inst.scene);
        matBox.diffuseTexture.hasAlpha = true;
        matBox.transparencyMode = 2;
        matBox.useAlphaFromDiffuseTexture = true;
        matBox.emissiveColor = BABYLON.Color3.White();
        matBox.disableLighting  = true;
        this.$options.floorMarker.material = matBox;
        this.$options.floorMarker.visibility = 0;
        this.$options.floorMarker.isPickable  = false;
      };

      assetsManager.addMeshTask("LODLCube Task", "", "https://activstoredev.blob.core.windows.net/test/CubemapTest/LOD2Cube.glb", "").onSuccess = (task) =>{

        task.loadedMeshes[0].scaling  = new BABYLON.Vector3(task.loadedMeshes[0].scaling.x * 1,task.loadedMeshes[0].scaling.y * 1,task.loadedMeshes[0].scaling.z * 1)
        this.$options.lodMeshes.push(task.loadedMeshes[0]);
        this.$options.lodLCube = task.loadedMeshes[0];
        this.$options.lodLCube.setParent(this.$options.lodCubeAlpha);
        task.loadedMeshes[0].position = new BABYLON.Vector3(0,0,0);
        task.loadedMeshes[0].name = "LOD L Cube";

         task.loadedMeshes.forEach(mesh => {
           mesh.alphaIndex = 1;
           mesh.isPickable = false;
        });
      };

      assetsManager.addMeshTask("LODMCube Task", "", "https://activstoredev.blob.core.windows.net/test/CubemapTest/LOD1Cube_7.glb", "").onSuccess = (task) =>{

        task.loadedMeshes[0].scaling  = new BABYLON.Vector3(task.loadedMeshes[0].scaling.x * 1,task.loadedMeshes[0].scaling.y * 1,task.loadedMeshes[0].scaling.z * 1)
        this.$options.lodMeshes.push(task.loadedMeshes[0]);
        this.$options.lodMCube = task.loadedMeshes[0];
        this.$options.lodMCube.setParent(this.$options.lodCubeAlpha);
        task.loadedMeshes[0].position = new BABYLON.Vector3(0,0,0);
        task.loadedMeshes[0].name = "LOD M Cube";

         task.loadedMeshes.forEach(mesh => {
           mesh.alphaIndex = 2;
           mesh.isPickable = false;
        });
      };

      assetsManager.addMeshTask("LODHCube Task", "", "https://activstoredev.blob.core.windows.net/test/CubemapTest/LOD1Cube_7.glb", "").onSuccess = (task) =>{

        task.loadedMeshes[0].scaling  = new BABYLON.Vector3(task.loadedMeshes[0].scaling.x * 0.90,task.loadedMeshes[0].scaling.y * 0.90,task.loadedMeshes[0].scaling.z * 0.90)
        this.$options.lodMeshes.push(task.loadedMeshes[0]);
        this.$options.lodHCube = task.loadedMeshes[0];
        this.$options.lodHCube.setParent(this.$options.lodCubeAlpha);
        task.loadedMeshes[0].position = new BABYLON.Vector3(0,0,0);
        task.loadedMeshes[0].name = "LOD H Cube";

         task.loadedMeshes.forEach(mesh => {
           mesh.alphaIndex = 3;
           mesh.isPickable = false;
        });
      };

      assetsManager.addMeshTask("LODUHCube Task", "", "https://activstoredev.blob.core.windows.net/test/CubemapTest/LOD1Cube_7.glb", "").onSuccess = (task) =>{

        task.loadedMeshes[0].scaling  = new BABYLON.Vector3(task.loadedMeshes[0].scaling.x * 0.85,task.loadedMeshes[0].scaling.y * 0.85,task.loadedMeshes[0].scaling.z * 0.85)
        this.$options.lodMeshes.push(task.loadedMeshes[0]);
        this.$options.lodUHCube = task.loadedMeshes[0];
        this.$options.lodUHCube.setParent(this.$options.lodCubeAlpha);
        task.loadedMeshes[0].position = new BABYLON.Vector3(0,0,0);
        task.loadedMeshes[0].name = "LOD UH Cube";

         task.loadedMeshes.forEach(mesh => {
           mesh.alphaIndex = 4;
           mesh.isPickable = false;
        });

        
      };

      //WA ONLY COLLIDERS
      assetsManager.addMeshTask("WA Walls Task", "", "https://xpcwa.blob.core.windows.net/assets/Walls7.glb", "").onSuccess = (task) =>{

        
         task.loadedMeshes.forEach(mesh => {
           mesh.visibility = 0;

           if(mesh.material != null)
           {
            mesh.material.disableLighting = true;
           }
        });
        
        
      };

       assetsManager.addMeshTask("WA Walls Task", "", "https://xpcwa.blob.core.windows.net/assets/WALLIO2.glb", "").onSuccess = (task) =>{

        
         task.loadedMeshes.forEach(mesh => {
           mesh.visibility = 0;

           if(mesh.material != null)
           {
            mesh.material.disableLighting = true;
           }
        });
        
        
      };

      assetsManager.addMeshTask("WA Walls Task", "", "https://xpcwa.blob.core.windows.net/assets/TunnelOccluder_1.glb", "").onSuccess = (task) =>{

                
        task.loadedMeshes.forEach(mesh => {
          mesh.visibility = 0;

          if(mesh.material != null)
          {
          mesh.material.disableLighting = true;
          }
        });


      };



      
      
      if(this.package.settings.uniqueProjectid == "nestle")
      {
        assetsManager.addMeshTask("Wallpaper Task", "", "https://activstoredev.blob.core.windows.net/test/nestle/" + "NestleColliders8" + ".glb", "").onSuccess = (task) =>{

          task.loadedMeshes[0].scaling = new BABYLON.Vector3(task.loadedMeshes[0].scaling.x * 1, task.loadedMeshes[0].scaling.y, task.loadedMeshes[0].scaling.z);
          task.loadedMeshes[0].rotation = new BABYLON.Vector3(0,0,0);

          
          for (let e = 0; e < task.loadedMeshes.length; e++) {
            const element = task.loadedMeshes[e];
            if(element.visibility != 0)
              element.visibility = 0;
          }

        };
      }

      //assetsManager.addMeshTask("NestleWallpaper", "", "")

      var initialWaypointsToLoad = this.GetAllWaypointsInRange(this.currentWaypoint,25);
      this.AddWaypointsToLoader(initialWaypointsToLoad,assetsManager);

      assetsManager.onFinish = (tasks) => {
        
        this.isInitalized = true;
        this.ProcessWaypoints();

        initialWaypointsToLoad.forEach(waypoint => {
          this.$options.loadedWaypoints.push(waypoint);
        });

        

        this.$options.lodCubeBeta = this.$options.lodCubeAlpha.clone("LOD Cube Beta");

        this.$options.lodCubeAlpha.getChildMeshes().forEach(mesh => {
          if(mesh.material != null)
          {
            mesh.material = new BABYLON.StandardMaterial("Alpha_" + mesh.name,inst.scene);
            mesh.material.transparencyMode = 2;
            mesh.material.disableLighting = true;
            mesh.visibility = 0;

            if(mesh.visibility != null && mesh.visibility != 0)
              mesh.visibility = 0;
          }
        })
        this.$options.lodCubeBeta.getChildMeshes().forEach(mesh => {
          mesh.name = mesh.name.replace("LOD Cube Beta.","");
          mesh.name = mesh.name.replace(mesh.parent.name +  ".","");
          if(mesh.material != null)
          {
            mesh.material = new BABYLON.StandardMaterial("Beta_" + mesh.name,inst.scene);
            mesh.material.disableLighting = true;

            if(mesh.visibility != null && mesh.visibility != 0)
              mesh.visibility = 0;
          }
        })

        this.$options.currentCube = null;
        this.$options.targetCube = this.$options.lodCubeAlpha;

        this.NavigateToWaypoint(this.waypoint);
        
        this.StartLODLoop();
        this.$emit("envLoaded");

      };
      assetsManager.load();
    },
    BeginLoadTextureForMeshFromUrl(waypointid,mesh,TextureUrl,scene,onLoad)
    {
      if(mesh.material == null || mesh.material.getClassName() == "PBRMaterial")
      {
        if(mesh.material != null)
          mesh.material.dispose();

        mesh.material = new BABYLON.StandardMaterial(mesh.name,scene);
      }

      mesh.material.disableLighting = true;
      var newTex = new BABYLON.Texture(TextureUrl, scene,{noMipmap : true},undefined,undefined,() => {

        let index = this.$options.loadingTextureObjects.findIndex(obj => obj.url == TextureUrl);

        if(index != -1)
        {
          this.$options.loadingTextureObjects.splice(index,1);
        }

        if(this.currentWaypoint.id != waypointid)
        {
          newTex.dispose();
          return;
        }
        
        if(mesh.material.emissiveTexture != null)
        {
          mesh.material.emissiveTexture.dispose();
        }

        mesh.material.emissiveTexture = newTex;

        if(onLoad != null)
          onLoad(newTex);

      
      });
      newTex.wrapU = BABYLON.Texture.CLAMP_ADDRESSMODE;
      newTex.wrapV = BABYLON.Texture.CLAMP_ADDRESSMODE;
      newTex.anisotropicFilteringLevel = 8;
      this.$options.loadingTextureObjects.push(newTex);
    }

  },
  watch: {
  
    //If set to active and we've not initalized, let's then do so
    isActive : {
      handler(newVal)
      {
        if(newVal)
        {
          this.Init();
        }
      }
    },
    fadeModel : {
      handler(newVal)
      {

        if(newVal)
        {
          this.transitionMethod = "FADE";
        }
        else
        {
          this.transitionMethod = "FADE1";
        }
      }
    },
    waypoint : {
      immediate : true,
      handler(newVal)
      {
        if(newVal != null)
        {
          this.currentWaypoint = newVal;
          this.$appInsights.trackEvent({name: "navigate_to_waypoint", properties: {id : newVal.id}});

          this.SetVideoGroupsToPlay(newVal.id);

          this.videoGroups.forEach(vidGrp => {

            if(vidGrp.waypoints.includes(newVal.id))
            {
              vidGrp.meshes.forEach(mesh => {

                mesh.material.alpha = 1;

              })
            }
            else
            {
              vidGrp.meshes.forEach(mesh => {

                mesh.material.alpha = 0;

              })

            }

          })
        }
      }
    },
    currentWaypoint : {
      immediate : true,
      handler (newVal)
      {
        if(this.isInitalized && newVal != null)
        {
          this.NavigateToWaypoint(newVal);
        }
      }
    }
    
  }
}
</script>
